import type { TemplateOnlyComponent } from '@ember/component/template-only';

export interface Signature {
  Args: {
    class?: string;
  };
  Element: SVGElement;
}

const WrDoubleArrowDownIconComponent: TemplateOnlyComponent<Signature> =
  <template>
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      class={{@class}}
      ...attributes
    >
      <path
        d='M2.27509 7.49162C1.96282 7.17877 1.54647 7.17877 1.2342 7.49162C0.921932 7.80447 0.921932 8.2216 1.2342 8.53445L7.47955 14.7914C7.58364 14.8957 7.79182 15 8 15C8.20818 15 8.41636 14.8957 8.52045 14.7914L14.7658 8.53445C15.0781 8.2216 15.0781 7.80447 14.7658 7.49162C14.4535 7.17877 14.0372 7.17877 13.7249 7.49162L8 13.2272L2.27509 7.49162ZM8 6.97021L13.7249 1.23464C14.0372 0.921789 14.4535 0.921789 14.7658 1.23464C15.0781 1.54749 15.0781 1.96462 14.7658 2.27747L8.52045 8.53445C8.41636 8.63873 8.20818 8.74302 8 8.74302C7.79182 8.74302 7.58364 8.63873 7.47955 8.53445L1.2342 2.27747C0.921932 1.96462 0.921932 1.54749 1.2342 1.23464C1.54647 0.921789 1.96282 0.921789 2.27509 1.23464L8 6.97021Z'
        fill='currentColor'
      />
    </svg>
  </template>;

export default WrDoubleArrowDownIconComponent;
